module.exports = __webpack_public_path__ + "static/media/navigate-d8.df158fd6.svg";